import { IFsFileType } from "@/components/r3f-components/component-data-structure";
import { FsImage } from "./image";

export class FsImageTarget extends FsImage {
    type: IFsFileType.ImageTarget = IFsFileType.ImageTarget
    private _fullZptBody: ArrayBuffer | undefined
    private _trackingData: ArrayBuffer | undefined
    private _img: ArrayBuffer | undefined

    constructor(fileId: string, name: string) {
        super(fileId, name)
        const url = new URL(this.baseUrl)
        url.pathname = `${url.pathname}/img`
        this.imageUrl = url.toString()
    }

    async getImage() {
        if (typeof this._img === 'undefined') {
            await this._parseZptBody()
        }
        return this._img
    }

    async getZpt() {
        if (typeof this._trackingData !== 'undefined') return this._trackingData
        await this._parseZptBody()
        return this._trackingData
    }

    async _parseZptBody() {
        const zpt = await this.getZptBody()
        const headerOffset = 32;
        const header = (new TextDecoder()).decode(zpt.slice(0, headerOffset))
        if (!header.startsWith('ZPT+IMG')) {
            console.warn('Older ZPT:', header.toString())
            this._trackingData = zpt;
            this.imageUrl = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
            this._img = new ArrayBuffer(0)
            return
        }
        const parts = header.replace('ZPT+IMG', '').split(';')
        // const mimeType = parts[1].replaceAll('\x00', '')
        const zptSizeStr = parts[0]
        const zptSize = parseInt(zptSizeStr)
        this._img = zpt.slice(headerOffset + zptSize)
        this._trackingData = zpt.slice(headerOffset, headerOffset + zptSize)
        // In some places in the React app, we need an image URL
        const blob = new Blob([new Uint8Array(this._img)])
        this.imageUrl = URL.createObjectURL(blob)
    }

    async getZptBody() {
        if (typeof this._fullZptBody === 'undefined') {
            const url = new URL(this.baseUrl)
            url.pathname = `${url.pathname}/zpt`
            const resp = await fetch(url)
            this._fullZptBody = await resp.arrayBuffer()
        }
        return this._fullZptBody
    }
}
